window.addEventListener("load", function () {
    // function updateMilestoneState() {
    //     const soluot = parseInt($(".soluot").text().replace(/\D/g, ""), 10) || 0;
    //     $(".milestone .moc-item").each(function () {
    //         const milestoneNumber = parseInt($(this).data("number"), 10);
    //         const $mocItem = $(this);
    //         if (milestoneNumber > soluot) {
    //             $mocItem.addClass("off");
    //         } else {
    //             $mocItem.removeClass("off");
    //         }
    //     });
    // }

    // updateMilestoneState();
});